const ITEM_ALREADY_EXISTS = 'Item already exists'
const ITEM_OUTDATED = "Item's version is outdated"

export default {
  ITEM_ALREADY_EXISTS,
  ITEM_OUTDATED
}
